"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var glamor_1 = require("glamor");
var FabricPerformance_1 = require("@uifabric/utilities/lib/FabricPerformance");
/**
 * Takes a collection of collection of styles, defined in various formats, and compresses them into
 * a single thing of one format to return.
 * If any class names (strings) are passed in, it will return a list of space-separated class names,
 * using glamor to generate a class name for all passed in style objects.
 * Otherwise, all style objects passed in will be compressed into a single IProcessedStyle.
 *
 * @export
 * @param {(...(IStyle | string)[])} args
 * @returns {IStyle}
 */
function mergeStyles() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    var rules = [];
    function _parseArgs(theArgs) {
        for (var _i = 0, theArgs_1 = theArgs; _i < theArgs_1.length; _i++) {
            var arg = theArgs_1[_i];
            if (arg) {
                if (typeof arg === 'string') {
                    classes.push(arg);
                }
                else if (Array.isArray(arg)) {
                    _parseArgs(arg);
                }
                else {
                    rules.push(arg);
                }
            }
        }
    }
    _parseArgs(args);
    var rulesObject = null;
    if (rules.length) {
        FabricPerformance_1.FabricPerformance.measure('glamor.css', function () {
            rulesObject = glamor_1.css.apply(void 0, rules);
        });
    }
    if (classes.length) {
        if (rulesObject) {
            classes.push(rulesObject.toString());
        }
        return classes.join(' ');
    }
    return rulesObject || {};
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=mergeStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/styling/lib/utilities/mergeStyles.js
// module id = 33
// module chunks = 0